<a class="block w-full p-3 border border-gray-200 rounded-lg" [ngClass]="isDisabled ? 'bg-gray-100': 'bg-white'">
    <mat-expansion-panel [expanded]="true" class="bg-inherit">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h5 class="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">{{"text.recurrence_schedule" | translate}}</h5>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form [formGroup]="formGroup" (submit)="formSubmit()" class="px-2 bg-inherit">
            <div class="grid grid-cols-6 gap-6 mb-6 mt-5">
        
                <!-- Recurrence Start From -->
                <div class="col-span-3">
                    <label for="startFrom" class="block text-base font-medium text-gray-700">
                        {{"recurrence.label.recurrence_start_from" | translate}}
                        <span class="mandatory-field">*</span> 
                    </label>
                    <input 
                        [matDatepicker]="startFrom"
                        (dateChange)="setFormChange()"
                        type="text" 
                        name="startFrom" 
                        id="startFrom"  
                        formControlName="startFrom"
                        class="mt-1 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-inherit shadow-sm px-3 py-3 leading-none text-base cursor-pointer"
                        placeholder="{{'recurrence.placeholder.recurrence_start_from' | translate}}"
                        (click)="startFrom.open()"
                        [datePickerFormat]="dateFormat"
                    >
                    <p class="text-red-500 text-base mt-1" *ngIf="utilityService.getErrorMessage(formGroup, 'startFrom')">{{utilityService.getErrorMessage(formGroup, 'startFrom') | translate}}</p>
                    <mat-datepicker #startFrom></mat-datepicker>
                </div>
        
                <!-- Recurrence Duration -->
                <form class="col-span-3" [formGroup]="formGroup.get('duration')">
                    <label for="duration" class="block text-base font-medium text-gray-700">
                        {{"recurrence.label.duration" | translate}}
                        <span class="mandatory-field">*</span> 
                    </label>
                    <div class="flex">
                        <input 
                            type="number" 
                            name="duration" 
                            formControlName="value"
                            (change)="setFormChange()"
                            id="duration" 
                            class="mt-1 w-3/6 block w-full rounded-l-md border border-gray-300 focus:border-indigo-500 bg-inherit shadow-sm px-3 py-3 leading-none text-base"
                            placeholder="{{'recurrence.placeholder.duration' | translate}}"
                        > 
                        <span [matMenuTriggerFor]="dropdown" class="inline-flex cursor-pointer items-center mt-1 px-3 text-base text-gray-900 border border-l-0 border-gray-300 rounded-r-md">
                            {{durationObj[duration.get('type').value]}}
                            <em class="text-xl" class="ti ti-chevron-down ml-2 text-base font-semibold"></em>
                        </span>
                        <mat-menu #dropdown="matMenu">
                            <div *ngFor="let key of getDurationArray()">
                              <a mat-menu-item  (click)="selectDuration(key); checkFormChange()" class="primary-font text-base h-10 text-gray-700">
                                <span class="ml-2">{{durationObj[key]}}</span>
                              </a>
                            </div>
                          </mat-menu>
                    </div>
                    <p class="text-red-500 text-base mt-1" *ngIf="utilityService.getErrorMessage(duration, 'value')">{{utilityService.getErrorMessage(formGroup.get('duration'), 'value') | translate}}</p>
                </form>
        
                <!-- Job Start time -->
                <div class="col-span-3">
                    <label for="startTime" class="block text-base font-medium text-gray-700">
                        {{"text.job_start_time" | translate}}
                        <span class="mandatory-field">*</span> 
                    </label>
                    <input 
                        [matMenuTriggerFor]="startTime"
                        type="text" 
                        [name]="'startTime'" 
                        readonly
                        [id]="'startTime'" 
                        [ngModel]="timePickerData['startTime']"
                        (ngModelChange)="setFormChange()"
                        [ngModelOptions]="{standalone: true}"
                        class="mt-1 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-inherit shadow-sm px-3 py-3 leading-none text-base cursor-pointer"
                        placeholder="{{'recurrence.placeholder.time' | translate}}"
                        >
                    <p class="text-red-500 text-base mt-1" *ngIf="utilityService.getErrorMessage(formGroup, 'startTime')">{{utilityService.getErrorMessage(formGroup, 'startTime') | translate}}</p>
                    <mat-menu #startTime="matMenu">
                        <div class="flex flex-col">
                            <div class="flex justify-center">
                            <ngx-mat-timepicker #startTimePicker (click)="$event.stopPropagation()"
                            [showSpinners]="true"
                            [stepHour]="1" [stepMinute]="startTimeStepper"
                            [showSeconds]="false"
                            [enableMeridian]="enableMeridian"
                            [(ngModel)]="timePickerModel['startTime']"
                            (ngModelChange)="setTimeFormControl('startTime', $event);startTimeChange()"
                            [ngModelOptions]="{standalone: true}"
                            >
                            </ngx-mat-timepicker>
                            </div>
                        </div>
                    </mat-menu>
                </div>
        
                <!-- Job End time -->
                <div class="col-span-3">
                    <label for="endTime" class="block text-base font-medium text-gray-700">
                        {{"text.job_end_time" | translate}}
                        <span class="mandatory-field">*</span> 
                    </label>
                    <input 
                        [matMenuTriggerFor]="endTime"
                        type="text" 
                        [name]="'endTime'"
                        readonly 
                        [id]="'endTime'" 
                        [ngModel]="timePickerData['endTime']"
                        (ngModelChange)="setFormChange()"
                        [ngModelOptions]="{standalone: true}"
                        class="mt-1 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-inherit shadow-sm px-3 py-3 leading-none text-base cursor-pointer"
                        placeholder="{{'recurrence.placeholder.time' | translate}}"
                        >
                    <p class="text-red-500 text-base mt-1" *ngIf="utilityService.getErrorMessage(formGroup, 'endTime')">{{utilityService.getErrorMessage(formGroup, 'endTime') | translate}}</p>
                    <mat-menu #endTime="matMenu">
                        <div class="flex flex-col">
                            <div class="flex justify-center">
                            <ngx-mat-timepicker #endTimePicker (click)="$event.stopPropagation()"
                            [showSpinners]="true"
                            [stepHour]="1" [stepMinute]="endTimeStepper"
                            [showSeconds]="false"
                            [enableMeridian]="enableMeridian"
                            [(ngModel)]="timePickerModel['endTime']"
                            (ngModelChange)="setTimeFormControl('endTime', $event);endTimeChange()"
                            [ngModelOptions]="{standalone: true}"
                            >
                            </ngx-mat-timepicker>
                            </div>
                        </div>
                    </mat-menu>
                </div>
            </div>
            <app-rrule [option]="rruleOptions" *ngIf="showRrule" [isDisabled]="isDisabled" (eventChange)="getRrule($event)"></app-rrule>
            <!-- Added for testing purpose -->
        </form>
    </mat-expansion-panel>
</a>
